module.exports = __webpack_public_path__ + "img/shhs_10yr_header.e4c33557.png";